import "./Highlights.css";

/** "Worth a look": a short list of things to act on, each with one action.
 *  items: [{ key, text, action: { label, ... } }] from highlightRules.js. */
export default function Highlights({ items, loading, onAction }) {
  const shown = items.filter(Boolean);
  if (!shown.length && !loading) return null;
  return <section className="sa-look" aria-labelledby="sa-look-title" aria-busy={loading || undefined}>
    <h3 id="sa-look-title" className="sa-section-title">Worth a look</h3>
    <ul className="sa-look-list">
      {shown.map((item) => <li key={item.key}>
        <span>{item.text}</span>
        {item.action && <button type="button" className="sa-look-action" onClick={() => onAction(item.action)}>{item.action.label}</button>}
      </li>)}
      {loading && <li className="is-loading"><span>Checking customers and salesmen…</span></li>}
    </ul>
  </section>;
}
